import React, { useRef, memo, useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { API_TOKEN_NAME } from "../../constants";
import { scAxiosAdmin } from "../..";

const NewReachTextEditor = ({ id, value, onChange }) => {
  const [licenseKey, setLicenseKey] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxiosAdmin.request(`/settings/29`, {
          method: "get",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
          params: {
            // ...data
          },
        });
        setLicenseKey(response.data.value);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const editorRef = useRef(null);

  return (
    <div>
      {licenseKey ? (
        <Editor
          apiKey={licenseKey}
          value={value} // Bind the current value
          onEditorChange={(content) => onChange(id, content)} // Handle changes
          init={{
            height: 500,
            menubar: true,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "fontselect",
              "code",
              "help",
              "wordcount",
            ],
            toolbar:
              "undo redo | blocks " +
              "bold italic forecolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "table |image| media| removeformat | help",
            content_style: `
            body { font-family:Helvetica,Arial,sans-serif; font-size:14px }
            table {
              border-collapse: collapse;
              width: 100%;
            }
            table, th, td {
              border: 1px solid #ccc;
              padding: 8px;
            }
            th {
              background-color: #f2f2f2;
            }
          `,
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(NewReachTextEditor, (prevProps, nextProps) => {
  return prevProps.value === nextProps.value && prevProps.id === nextProps.id;
});



// WEBPACK FOOTER //
// ./src/component/admin/NewReachTextEditor.js